import * as $ from "jquery";
import { Toggle } from "./typescript/Vgr.Ui";
import { placeCursorAtEndOf } from "./typescript/Vgr.Util";
import initializeAutocomplete from "./AutocompleteSearch";


$(document).ready(function () {
    // Only the normal Hitta search has query completion so far
    if ($("#hitta-search").length > 0) {
        initializeAutocomplete();
    }
   
    // Init toggle
    $(".vgr-toggle").each(function () {
        let st = new Toggle($(this));
    });

    let searchField = $("#search");
    if (searchField.length > 0) {
        placeCursorAtEndOf(searchField);
    }

    $(".launch-guide").on("click", function (e) {
        e.preventDefault();

        guideClick("/api/hittasearch/launchguide", "Hitta");
    });

    $(".document-launch-guide").on("click", function (e) {
        e.preventDefault();

        guideClick("/api/hittasearch/launchguide", "HittaDocument");
    });

    $(".mellanarkivet-launch-guide").on("click", function (e) {
        e.preventDefault();

        guideClick("/api/hittasearch/launchguide", "HittaIArkivet");
    });

    function guideClick(ajaxUrl, guideName) {
        let searchText = $("#search").val();
        let pageId = document.head.querySelector('meta[name="SidID"]').getAttribute("content");
        if ($("#guide").length) {
            $(".header").nextAll().toggle(300);
            launchGuide(searchText);
        } else {
            $.ajax({
                url: ajaxUrl,
                type: "GET",
                dataType: "html",
                data: { pageId: pageId, guideName: guideName },
                success: function (data) {
                    $(".header").nextAll().toggle(300);
                    $(".header").after(data).fadeIn();
                    launchGuide(searchText);
                },
                error: function (xhr, status, error) { },
            });
        }
    }

    function launchGuide(searchText) {
        let searchboxValue = $("#guide").data("searchboxvalue");

        $("#search").val(searchboxValue);
        $(".guide").joyride({
            autoStart: true,
            tipLocation: "bottom",
            modal: true,
            template: {
                link: '<button class="joyride-close-tip close"><span class="visually-hidden">Stäng</span></button>',
            },
            postRideCallback: function () {
                $(".header").nextAll().toggle(300);
                $("#search").val(searchText);
                $("#search").focus();
            },
        });
    }

    // Global shortcut to access the search field (CTRL + E)
    document.addEventListener("keydown", function (e) {
        if (e.key === "e" && e.ctrlKey) {
            e.preventDefault(); // Prevent browser from doing their own search thing
            let search$ = $("input[type=search]")[0];
            if (search$) search$.focus();
        }
    });
});
